import {
  isLink,
  isBlockquote,
  isThematicBreak,
  Document,
  isListItem,
  isList
} from "datocms-structured-text-utils"
import {StructuredText, renderNodeRule} from "react-datocms"
import type {FC} from "react"

import {Anchor} from "components/Anchor"

import styles from "./small-text.module.css"

interface Props {
  data: Document
}

const linkNode = renderNodeRule(isLink, ({node, children, key}) => (
  <Anchor key={key} href={node.url} className="!text-xl text-blue-link">
    {children}
  </Anchor>
))

const blockquoteNode = renderNodeRule(isBlockquote, ({children, key}) => (
  <div key={key} className="py-5">
    <blockquote className={styles.nomargin}>{children}</blockquote>
  </div>
))

const hrNode = renderNodeRule(isThematicBreak, ({key}) => (
  <hr className="break-line border-0" key={key} />
))

const list = renderNodeRule(isList, ({children, node, key}) => {
  if (node.style === "bulleted") {
    return <ul className={styles.bulletedList} key={key}>{children}</ul>
  }

  return <ol className={styles.numberedList} key={key}>{children}</ol>
})

const listItem = renderNodeRule(isListItem, ({children, key}) => {
  return (
    <li key={key}>{children}</li>
  )
})

export const SmallText: FC<Props> = ({data}) => (
  <div className={styles.nomargin}>
    <StructuredText
      data={data}
      customNodeRules={[linkNode, blockquoteNode, hrNode, list, listItem]}
    />
  </div>
)
